import {MutationTree} from 'vuex';
import {
  EntityMember,
  Member,
  MemberInitState,
  MemberTimeInformation,
  StarTransactionAVG
} from '@/store/member/member.types';
import {Invite, ServiceFormSearch} from '@/class/service-form.interface';

export const MemberMutations: MutationTree<MemberInitState> = {
  ['mutationGetMember'](state: MemberInitState, payload: Member[]) {
    state.member = payload;
  },
  ['mutationGetMemberFromService'](state: MemberInitState, payload: Member[]) {
    state.getMemberFromService = payload;
  },
  ['mutationGetMemberProfile'](state: MemberInitState, payload: EntityMember) {
    state.profile = payload;
  },
  ['mutationGetMemberBondsman'](state: MemberInitState, payload: Member) {
    state.bondsman = payload;
  },
  ['mutationCheckMobile'](state: MemberInitState, payload: number) {
    state.checkMobile = payload;
  },
  ['mutationTimeTotal'](state: MemberInitState, payload: string) {
    state.timeTotal = payload;
  },
  ['mutationSetFormSearch']: (state: MemberInitState, payload: ServiceFormSearch) => state.serviceFormSearch = payload,
  ['mutationSetInviteList']: (state: MemberInitState, payload: Invite[]) => state.inviteList = payload,
  ['mutationSetTimeInformation']: (state: MemberInitState, payload: MemberTimeInformation) => {
    state.timeInformation = payload
  },
  ['mutationSetVisitorRemain']: (state: MemberInitState, payload: string) => {
    state.component.profileVisit.remain = payload
  },
  ['mutationSetVisitorId']: (state: MemberInitState, payload: string) => {
    state.component.profileVisit.getMemberId = payload
  },
  ['mutationSetStartTransaction']: (state: MemberInitState, payload: StarTransactionAVG[]) => {
    console.log('DEBUG: payload', payload);
    state.component.profileVisit.starTransaction = payload
  },
};
